
import { defineComponent } from "vue";
import TokenService from "@/services/tokenService";
import * as apiClient from "@/apiclient/";
import routesPath from "@/config/routesPath";
import common from "@/config/common";

export default defineComponent({
  name: "MFAView",
  data() {
    return {
      mfaToken: null as string | null,
      mounted: false,
      credentials: [] as apiClient.GetApiMfaGetmfacredentials200 | undefined,
      /*
        Step Explained:
        1: Credential Select
        2: Code Subission
      */
      step: 1 as number,
      submitted: false as boolean,
      selectedCredentialID: undefined as number | undefined,
      mfaCode: null as string | null,
      instructions: undefined as string | undefined,
      submitValidationMessage: null as string | null,
      isCodeWrong: false as boolean,
    };
  },
  mounted() {
    this.mfaToken = TokenService.getToken(common.storageVariables.mfaToken);

    if (!this.mfaToken) {
      var accessToken = TokenService.getAccessToken();
      if (accessToken) {
        this.$router.push({ name: routesPath.enrollments });
        return;
      } else {
        TokenService.logout();
        this.$router.push({ name: routesPath.getStarted });
        return;
      }
    }

    this.getMFACredentials();
    this.mounted = true;
  },
  methods: {
    async selectCredential() {
      this.submitted = true;
      if (!this.selectedCredentialID) {
        return;
      }

      var result = await apiClient
        .MFAController()
        .postApiMfaSelectcredential(this.selectedCredentialID, {
          headers: { Authorization: "Bearer " + this.mfaToken },
        });

      this.instructions = result.data;
      this.step = 2;
      this.submitted = false;
    },
    async submitMFACode() {
      this.isCodeWrong = false;
      this.submitted = true;
      if (!this.mfaCode) {
        this.submitValidationMessage = "Code is required.";
        return;
      }

      this.submitValidationMessage = null;
      var result = await apiClient.MFAController().postApiMfaValidatecode(
        {
          credentialId: this.selectedCredentialID,
          mfaCode: this.mfaCode,
        },
        {
          headers: { Authorization: "Bearer " + this.mfaToken },
        }
      );

      var response = result.data;
      if (response?.result == 0) {
        TokenService.logout();
        const token: string = result.data?.accessToken?.token || "";
        const refreshToken: string =
          result.data?.accessToken?.refreshToken || "";

        TokenService.setAccessToken(token);
        TokenService.setRefreshToken(refreshToken);
        this.$router.push({ name: routesPath.enrollments });
        return;
      } else {
        this.submitValidationMessage =
          "Code is expired or incorrect, please try again.";
        this.isCodeWrong = true;
      }
    },
    async getMFACredentials() {
      var result = await apiClient.MFAController().getApiMfaGetmfacredentials({
        headers: { Authorization: "Bearer " + this.mfaToken },
      });

      this.credentials = result.data;
    },
  },
  computed: {
    isSubmitValidationMessageVisible() {
      if (!this.submitted) {
        return false;
      }

      if (!this.isCodeWrong && this.mfaCode) {
        return false;
      }

      if (this.submitValidationMessage) {
        return true;
      }

      return false;
    },
  },
});
